import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './employee-base-rate.reducer';

export const selectEmployeeBaseRateState =
    createFeatureSelector<fromReducer.State>(
        fromReducer.employeeBaseRatesFeatureKey
    );

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromReducer.adapter.getSelectors(selectEmployeeBaseRateState);
